// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  GET_INCIDENTS_SUCCESS,
  GET_INCIDENTS_ERROR,
  GET_INCIDENTS,
} from "../../constants";
import axios from "../../../../services/api";

function* getIncidentsRequest(data) {
  const params = new URLSearchParams();

  if (data.ordering) {
    params.append("ordering", data.ordering);
  }
  if (data.search) {
    params.append("search", data.search);
  }
  if (data.page) {
    params.append("page", data.page);
  }
  try {
    const response = yield call(axios.get, `/incidents/`, { params });
    if (response.data.error) {
      yield put({
        type: GET_INCIDENTS_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: GET_INCIDENTS_SUCCESS,
        data: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: GET_INCIDENTS_ERROR,
      data: error,
    });
  }
}

export default function* getIncidentsRequestSaga() {
  yield takeLatest(GET_INCIDENTS, getIncidentsRequest);
}
